// src/services/api/attributes.js
import { apiClient } from './base';

export const createProductAttribute = async (attributeData) => {
  try {
    const response = await apiClient.post('/product-attributes', attributeData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProductAttributes = async (params = {}) => {
  try {
    const response = await apiClient.get('/product-attributes', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProductAttribute = async (attributeId) => {
  try {
    const response = await apiClient.get(`/product-attributes/${attributeId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateProductAttribute = async (attributeId, attributeData) => {
  try {
    const response = await apiClient.put(`/product-attributes/${attributeId}`, attributeData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteProductAttribute = async (attributeId) => {
  try {
    const response = await apiClient.delete(`/product-attributes/${attributeId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createAttributeValue = async (attributeId, valueData) => {
  try {
    const response = await apiClient.post(`/product-attributes/${attributeId}/values`, valueData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAttributeValue = async (attributeId, valueId, valueData) => {
  try {
    const response = await apiClient.put(`/product-attributes/${attributeId}/values/${valueId}`, valueData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAttributeValue = async (attributeId, valueId) => {
  try {
    const response = await apiClient.delete(`/product-attributes/${attributeId}/values/${valueId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};